import { Link } from "react-router-dom";
import { LOGO, SITE, WHATSAPP } from "@/lib/brand";
import { InstallButton } from "./InstallButton";

export const BrandHeader = () => (
  <header className="no-print relative z-20 flex items-center justify-between px-6 md:px-12 py-5">
    <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-3">
      <span className="bg-[var(--green)] rounded-2xl p-2 shadow-lg">
        <img src={LOGO} alt="Catalyst Crew" className="h-10 w-auto" />
      </span>
      <span className="hidden sm:block leading-tight">
        <span className="block font-extrabold tracking-tight text-lg">Content<em className="font-serif-cc font-normal">Catalyst</em></span>
        <span className="block text-xs text-[var(--muted)] uppercase tracking-[0.2em]">by Catalyst Crew</span>
      </span>
    </Link>
    <nav className="flex items-center gap-3 text-sm">
      <a href={SITE} target="_blank" rel="noreferrer" data-testid="header-site-link"
        className="hidden md:inline hover:underline underline-offset-4 mr-2">catalystcrew.in</a>
      <InstallButton />
      <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="header-contact-btn"
        className="rounded-full bg-[var(--green)] text-[var(--cream)] px-5 py-2.5 font-semibold hover:bg-[var(--green-2)] transition-colors">
        Talk to the crew
      </a>
    </nav>
  </header>
);
